// const BASE_URL = "https://backend.maamaas.com/food/api/vendor/aboutus";
// const BASE_URLS = "https://backend.maamaas.com/food/api/adminteam";

// const getToken = () => localStorage.getItem("authToken");
// const getVendorId = () => localStorage.getItem("vendorId");

// export const aboutUsService = {

//     // GET
//     getAboutUs: async () => {
//         const token = getToken();
//         const vendorId = getVendorId();



//         try {
//             const response = await fetch(`${BASE_URL}/get/${vendorId}`, {
//                 method: "GET",
//                 headers: {
//                     "Authorization": `Bearer ${token}`,
//                     "Content-Type": "application/json"
//                 }
//             });


//             const data = await response.json();

//             return data;
//         } catch (error) {
//             console.error("🔴 [getAboutUs] Error:", error);
//             throw error;
//         }
//     },

//     // UPDATE About Us - Match exactly what works in Postman
//     updateAboutUs: async (aboutUsId, aboutText, imageFile, existingImage) => {
//         const token = getToken();
//         const vendorId = getVendorId();

//         const formData = new FormData();

//         // IMPORTANT: Send ONLY the fields you want to update, not the entire object
//         // This matches exactly what works in Postman
//         const updateData = {};

//         // Only add aboutUs if we're updating text
//         if (aboutText !== undefined && aboutText !== null) {
//             updateData.aboutUs = aboutText;
//         }

//         // Add aboutUsId for reference (optional but safe)
//         updateData.aboutUsId = aboutUsId;


//         // Send as TEXT/JSON, not as a Blob - match Postman exactly
//         formData.append("aboutUsData", JSON.stringify(updateData));

//         // If there's a new image file, append it
//         if (imageFile) {
//             formData.append("image", imageFile);
//         }

//         // Log form data for debugging
//         for (let pair of formData.entries()) {
//             if (pair[1] instanceof File) {
//                 // console.log("🟡 FormData:", pair[0], `File: ${pair[1].name}, size: ${pair[1].size}`);
//             } else {
//                 // console.log("🟡 FormData:", pair[0], pair[1]);
//             }
//         }

//         try {
//             const response = await fetch(`${BASE_URL}/update/${aboutUsId}`, {
//                 method: "PUT",
//                 headers: {
//                     "Authorization": `Bearer ${token}`
//                     // Don't set Content-Type - let browser set it with boundary
//                 },
//                 body: formData
//             });

//             const responseText = await response.text();

//             if (!response.ok) {
//                 throw new Error(`HTTP ${response.status}: ${responseText || "Unknown error"}`);
//             }

//             let data;
//             try {
//                 data = responseText ? JSON.parse(responseText) : {};
//                 // console.log("🟡 Parsed response:", data);
//             } catch (e) {
//                 // console.log("🟡 Could not parse response as JSON, using empty object");
//                 data = {};
//             }

//             return data;
//         } catch (error) {
//             console.error("🔴 [updateAboutUs] Error:", error);
//             throw error;
//         }
//     },

//     // Update Text Only - Uses the same endpoint but only sends aboutUs field
//     updateAboutUsText: async (aboutUsId, aboutText) => {


//         // Just call updateAboutUs with text only, no image
//         return await aboutUsService.updateAboutUs(aboutUsId, aboutText, null, "");
//     },

//     // Create About Us - New creation
//     // Create About Us - New creation
//     createAboutUs: async (aboutText, imageFile) => {
//         const token = getToken();
//         const vendorId = getVendorId();


//         const formData = new FormData();

//         // For creation, send minimal required data
//         const createData = {
//             aboutUsId: 0,
//             aboutUs: aboutText || "",
//             vendorId: Number(vendorId)
//         };


//         // ✅ IMPORTANT: Send as Blob with explicit content type
//         const jsonBlob = new Blob([JSON.stringify(createData)], { type: "application/json" });
//         formData.append("aboutUsData", jsonBlob);

//         if (imageFile) {
//             formData.append("image", imageFile);
//         }

//         // Log form data for debugging
//         for (let pair of formData.entries()) {
//             if (pair[1] instanceof File) {
//                 // console.log("🟢 FormData:", pair[0], `File: ${pair[1].name}, size: ${pair[1].size}, type: ${pair[1].type}`);
//             } else {
//                 // console.log("🟢 FormData:", pair[0], pair[1]);
//             }
//         }

//         try {
//             const response = await fetch(`${BASE_URL}/add/${vendorId}`, {
//                 method: "POST",
//                 headers: {
//                     "Authorization": `Bearer ${token}`
//                     // ✅ DON'T set Content-Type - let browser set it with boundary
//                 },
//                 body: formData
//             });

//             const responseText = await response.text();

//             if (!response.ok) {
//                 throw new Error(`HTTP ${response.status}: ${responseText}`);
//             }

//             return responseText ? JSON.parse(responseText) : {};
//         } catch (error) {
//             console.error("🔴 [createAboutUs] Error:", error);
//             throw error;
//         }
//     },

//     // GET mission + vision
//     // GET mission + vision
//     getMissionVision: async () => {
//         const token = getToken();
//         const vendorId = getVendorId();

//         try {
//             const response = await fetch(`${BASE_URL}/get/${vendorId}`, {
//                 method: "GET",
//                 headers: {
//                     "Authorization": `Bearer ${token}`,
//                     "Content-Type": "application/json"
//                 }
//             });

//             const data = await response.json();

//             // Return the data directly (not wrapped in .data)
//             return data;
//         } catch (error) {
//             console.error("🔴 [getMissionVision] Error:", error);
//             throw error;
//         }
//     },

//     // UPDATE mission + vision - Match exactly what works in Postman
//     updateMissionVision: async (aboutUsId, mission, vision, missionImage, visionImage) => {
//         const token = getToken();
//         const vendorId = getVendorId();



//         const formData = new FormData();

//         // Create update object with ONLY the fields we want to update
//         // This matches exactly what worked in Postman
//         const updateData = {};

//         // Only add mission if we're updating it (not empty string)
//         if (mission !== undefined && mission !== null) {
//             updateData.mission = mission;
//         }

//         // Only add vision if we're updating it (not empty string)
//         if (vision !== undefined && vision !== null) {
//             updateData.vision = vision;
//         }

//         // Add aboutUsId if needed (from your Postman, it's in the URL, not in the JSON)
//         // But let's include it to be safe
//         updateData.aboutUsId = aboutUsId;


//         // Send as TEXT/JSON (not as a Blob)
//         formData.append("aboutUsData", JSON.stringify(updateData));

//         // Add images if they exist - these are separate fields
//         if (missionImage) {
//             formData.append("missionImage", missionImage);
//         }

//         if (visionImage) {
//             formData.append("visionImage", visionImage);
//         }

//         // Log form data for debugging
//         for (let pair of formData.entries()) {
//             if (pair[1] instanceof File) {
//                 // console.log("🟢 FormData:", pair[0], `File: ${pair[1].name}, size: ${pair[1].size}`);
//             } else {
//                 // console.log("🟢 FormData:", pair[0], pair[1]);
//             }
//         }

//         try {
//             const response = await fetch(`${BASE_URL}/update/${aboutUsId}`, {
//                 method: "PUT",
//                 headers: {
//                     "Authorization": `Bearer ${token}`
//                 },
//                 body: formData
//             });

//             const responseText = await response.text();

//             if (!response.ok) {
//                 throw new Error(`HTTP ${response.status}: ${responseText}`);
//             }

//             return responseText ? JSON.parse(responseText) : {};
//         } catch (error) {
//             console.error("🔴 [updateMissionVision] Error:", error);
//             throw error;
//         }
//     },

//     // DELETE Mission Vision
//     deleteMissionVision: async (aboutUsId) => {
//         const token = getToken();

//         try {
//             const response = await fetch(`${BASE_URL}/delete/${aboutUsId}`, {
//                 method: "DELETE",
//                 headers: {
//                     "Authorization": `Bearer ${token}`,
//                     "Content-Type": "application/json"
//                 }
//             });

//             const text = await response.text();
//             return text ? JSON.parse(text) : {};
//         } catch (error) {
//             console.error("🔴 [deleteMissionVision] Error:", error);
//             throw error;
//         }
//     },

//     // ================= TEAM MANAGEMENT =================

//     // GET TEAM MEMBERS
//     getTeamMembers: async () => {
//         const vendorId = getVendorId();
//         const token = getToken();

//         try {
//             const response = await fetch(`https://backend.maamaas.com/food/api/adminteam/getall/${vendorId}`, {
//                 method: "GET",
//                 headers: {
//                     "Authorization": `Bearer ${token}`,
//                     "Content-Type": "application/json"
//                 }
//             });

//             if (!response.ok) {
//                 throw new Error("Failed to fetch team members");
//             }

//             const data = await response.json();
//             return data;
//         } catch (error) {
//             console.error("🔴 [getTeamMembers] Error:", error);
//             throw error;
//         }
//     },

//     // ADD MEMBER
//     addMember: async (name, designation, description, imageFile) => {
//         const vendorId = getVendorId();
//         const token = getToken();


//         const formData = new FormData();

//         const teamData = {
//             teamId: 0,
//             vendorId: Number(vendorId),
//             name: name,
//             designation: designation,
//             description: description,
//             image: ""
//         };


//         const jsonBlob = new Blob([JSON.stringify(teamData)], { type: "application/json" });
//         formData.append("teamData", jsonBlob);

//         if (imageFile) {
//             formData.append("image", imageFile);
//         }

//         // Log formData
//         for (let pair of formData.entries()) {
//         }

//         try {
//             const response = await fetch(
//                 `https://backend.maamaas.com/food/api/adminteam/addteam/${vendorId}`,
//                 {
//                     method: "POST",
//                     headers: {
//                         "Authorization": `Bearer ${token}`
//                     },
//                     body: formData
//                 }
//             );

//             const text = await response.text();

//             if (!response.ok) {
//                 console.error("API ERROR:", text);
//                 throw new Error("Add Member API Failed");
//             }

//             return text ? JSON.parse(text) : {};
//         } catch (error) {
//             console.error("🔴 [addMember] Error:", error);
//             throw error;
//         }
//     },

//     // UPDATE MEMBER
//     updateMember: async (teamId, name, designation, description, imageFile, existingImage) => {
//         const token = getToken();
//         const vendorId = getVendorId();

//         const formData = new FormData();

//         const teamData = {
//             teamId: teamId,
//             vendorId: Number(vendorId),
//             name: name,
//             designation: designation,
//             description: description,
//             image: existingImage || ""
//         };

//         formData.append(
//             "teamData",
//             new Blob([JSON.stringify(teamData)], { type: "application/json" })
//         );

//         if (imageFile) {
//             formData.append("image", imageFile);
//         }

//         try {
//             const response = await fetch(
//                 `https://backend.maamaas.com/food/api/adminteam/editbyid/${teamId}`,
//                 {
//                     method: "PUT",
//                     headers: {
//                         "Authorization": `Bearer ${token}`
//                     },
//                     body: formData
//                 }
//             );

//             const text = await response.text();

//             if (!response.ok) {
//                 console.error("Update API error:", text);
//                 throw new Error("Failed to update member");
//             }

//             return text ? JSON.parse(text) : {};
//         } catch (error) {
//             console.error("🔴 [updateMember] Error:", error);
//             throw error;
//         }
//     },

//     // DELETE MEMBER
//     // deleteMember: async (teamId) => {
//     //     const token = getToken();

//     //     console.log("🔴 [deleteMember] Starting...");
//     //     console.log("🔴 Team ID:", teamId);

//     //     try {
//     //         const response = await fetch(`https://backend.maamaas.com/food/api/adminteam/delete/${teamId}`, {
//     //             method: "DELETE",
//     //             headers: {
//     //                 "Authorization": `Bearer ${token}`,
//     //                 "Content-Type": "application/json"
//     //             }
//     //         });

//     //         if (!response.ok) {
//     //             throw new Error("Failed to delete member");
//     //         }

//     //         const data = await response.json();
//     //         console.log("🔴 Delete response:", data);
//     //         return data;
//     //     } catch (error) {
//     //         console.error("🔴 [deleteMember] Error:", error);
//     //         throw error;
//     //     }
//     // },


//     // DELETE MEMBER - Fix for object literal syntax (no 'static' keyword)
//     deleteMember: async (teamId) => {
//         const token = getToken();

//         try {
//             const response = await fetch(`https://backend.maamaas.com/food/api/adminteam/delete/${teamId}`, {
//                 method: "DELETE",
//                 headers: {
//                     "Authorization": `Bearer ${token}`,
//                     "Content-Type": "application/json"
//                 }
//             });


//             if (!response.ok) {
//                 throw new Error("Failed to delete member");
//             }

//             // Get response as text (since API returns "Deleted successfully" as plain text)
//             const textResponse = await response.text();

//             // Return success without trying to parse as JSON
//             return { success: true, message: textResponse };

//         } catch (error) {
//             console.error("🔴 [deleteMember] Error:", error);
//             throw error;
//         }
//     },

//     updateGallery: async (aboutUsId, formData) => {
//         const token = getToken();


//         // Log form data for debugging
//         for (let pair of formData.entries()) {
//             if (pair[1] instanceof File) {
//                 // console.log(`🟡 FormData: ${pair[0]} = File: ${pair[1].name}, size: ${pair[1].size}, type: ${pair[1].type}`);
//             } else {
//                 // console.log(`🟡 FormData: ${pair[0]} =`, pair[1]);
//             }
//         }

//         try {
//             const response = await fetch(
//                 `https://backend.maamaas.com/food/api/vendor/aboutus/update/${aboutUsId}`,
//                 {
//                     method: "PUT",
//                     headers: {
//                         "Authorization": `Bearer ${token}`
//                         // Don't set Content-Type - let browser set it with boundary
//                     },
//                     body: formData
//                 }
//             );


//             const responseText = await response.text();

//             if (!response.ok) {
//                 throw new Error(`HTTP ${response.status}: ${responseText}`);
//             }

//             let data;
//             try {
//                 data = responseText ? JSON.parse(responseText) : {};
//             } catch (e) {
//                 data = { message: responseText };
//             }

//             return data;
//         } catch (error) {
//             console.error("🔴 [updateGallery] Error:", error);
//             throw error;
//         }
//     },
//     // In aboutUsService.jsx, add this new method

//     // DELETE single image by ID
//     deleteImage: async (imageId) => {
//         const token = getToken();


//         try {
//             const response = await fetch(`https://backend.maamaas.com/food/api/aboutus/image/delete/${imageId}`, {
//                 method: "DELETE",
//                 headers: {
//                     "Authorization": `Bearer ${token}`,
//                     "Content-Type": "application/json"
//                 }
//             });


//             if (!response.ok) {
//                 const errorText = await response.text();
//                 throw new Error(`Failed to delete image: ${errorText}`);
//             }

//             const responseText = await response.text();

//             return { success: true, message: responseText };
//         } catch (error) {
//             console.error("🗑️ [deleteImage] Error:", error);
//             throw error;
//         }
//     },


// };






const BASE_URL = "https://backend.maamaas.com/food/api";

const getToken = () => localStorage.getItem("authToken");
const getVendorId = () => localStorage.getItem("vendorId");

export const aboutUsService = {

    // GET
    getAboutUs: async () => {
        const token = getToken();
        const vendorId = getVendorId();



        try {
            const response = await fetch(`${BASE_URL}/vendor/aboutus/get/${vendorId}`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            });


            const data = await response.json();

            return data;
        } catch (error) {
            console.error("🔴 [getAboutUs] Error:", error);
            throw error;
        }
    },

    // UPDATE About Us - Match exactly what works in Postman
    updateAboutUs: async (aboutUsId, aboutText, imageFile, existingImage) => {
        const token = getToken();
        const vendorId = getVendorId();

        const formData = new FormData();

        // IMPORTANT: Send ONLY the fields you want to update, not the entire object
        // This matches exactly what works in Postman
        const updateData = {};

        // Only add aboutUs if we're updating text
        if (aboutText !== undefined && aboutText !== null) {
            updateData.aboutUs = aboutText;
        }

        // Add aboutUsId for reference (optional but safe)
        updateData.aboutUsId = aboutUsId;


        // Send as TEXT/JSON, not as a Blob - match Postman exactly
        formData.append("aboutUsData", JSON.stringify(updateData));

        // If there's a new image file, append it
        if (imageFile) {
            formData.append("image", imageFile);
        }

        // Log form data for debugging
        for (let pair of formData.entries()) {
            if (pair[1] instanceof File) {
                // console.log("🟡 FormData:", pair[0], `File: ${pair[1].name}, size: ${pair[1].size}`);
            } else {
                // console.log("🟡 FormData:", pair[0], pair[1]);
            }
        }

        try {
            const response = await fetch(`${BASE_URL}/vendor/aboutus/update/${aboutUsId}`, {
                method: "PUT",
                headers: {
                    "Authorization": `Bearer ${token}`
                    // Don't set Content-Type - let browser set it with boundary
                },
                body: formData
            });

            const responseText = await response.text();

            if (!response.ok) {
                throw new Error(`HTTP ${response.status}: ${responseText || "Unknown error"}`);
            }

            let data;
            try {
                data = responseText ? JSON.parse(responseText) : {};
                // console.log("🟡 Parsed response:", data);
            } catch (e) {
                // console.log("🟡 Could not parse response as JSON, using empty object");
                data = {};
            }

            return data;
        } catch (error) {
            console.error("🔴 [updateAboutUs] Error:", error);
            throw error;
        }
    },

    // Update Text Only - Uses the same endpoint but only sends aboutUs field
    updateAboutUsText: async (aboutUsId, aboutText) => {


        // Just call updateAboutUs with text only, no image
        return await aboutUsService.updateAboutUs(aboutUsId, aboutText, null, "");
    },

    // Create About Us - New creation
    // Create About Us - New creation
    createAboutUs: async (aboutText, imageFile) => {
        const token = getToken();
        const vendorId = getVendorId();


        const formData = new FormData();

        // For creation, send minimal required data
        const createData = {
            aboutUsId: 0,
            aboutUs: aboutText || "",
            vendorId: Number(vendorId)
        };


        // ✅ IMPORTANT: Send as Blob with explicit content type
        const jsonBlob = new Blob([JSON.stringify(createData)], { type: "application/json" });
        formData.append("aboutUsData", jsonBlob);

        if (imageFile) {
            formData.append("image", imageFile);
        }

        // Log form data for debugging
        for (let pair of formData.entries()) {
            if (pair[1] instanceof File) {
                // console.log("🟢 FormData:", pair[0], `File: ${pair[1].name}, size: ${pair[1].size}, type: ${pair[1].type}`);
            } else {
                // console.log("🟢 FormData:", pair[0], pair[1]);
            }
        }

        try {
            const response = await fetch(`${BASE_URL}/vendor/aboutus/add/${vendorId}`, {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${token}`
                    // ✅ DON'T set Content-Type - let browser set it with boundary
                },
                body: formData
            });

            const responseText = await response.text();

            if (!response.ok) {
                throw new Error(`HTTP ${response.status}: ${responseText}`);
            }

            return responseText ? JSON.parse(responseText) : {};
        } catch (error) {
            console.error("🔴 [createAboutUs] Error:", error);
            throw error;
        }
    },

    // GET mission + vision
    // GET mission + vision
    getMissionVision: async () => {
        const token = getToken();
        const vendorId = getVendorId();

        try {
            const response = await fetch(`${BASE_URL}/vendor/aboutus/get/${vendorId}`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            });

            const data = await response.json();

            // Return the data directly (not wrapped in .data)
            return data;
        } catch (error) {
            console.error("🔴 [getMissionVision] Error:", error);
            throw error;
        }
    },

    // UPDATE mission + vision - Match exactly what works in Postman
    updateMissionVision: async (aboutUsId, mission, vision, missionImage, visionImage) => {
        const token = getToken();
        const vendorId = getVendorId();



        const formData = new FormData();

        // Create update object with ONLY the fields we want to update
        // This matches exactly what worked in Postman
        const updateData = {};

        // Only add mission if we're updating it (not empty string)
        if (mission !== undefined && mission !== null) {
            updateData.mission = mission;
        }

        // Only add vision if we're updating it (not empty string)
        if (vision !== undefined && vision !== null) {
            updateData.vision = vision;
        }

        // Add aboutUsId if needed (from your Postman, it's in the URL, not in the JSON)
        // But let's include it to be safe
        updateData.aboutUsId = aboutUsId;


        // Send as TEXT/JSON (not as a Blob)
        formData.append("aboutUsData", JSON.stringify(updateData));

        // Add images if they exist - these are separate fields
        if (missionImage) {
            formData.append("missionImage", missionImage);
        }

        if (visionImage) {
            formData.append("visionImage", visionImage);
        }

        // Log form data for debugging
        for (let pair of formData.entries()) {
            if (pair[1] instanceof File) {
                // console.log("🟢 FormData:", pair[0], `File: ${pair[1].name}, size: ${pair[1].size}`);
            } else {
                // console.log("🟢 FormData:", pair[0], pair[1]);
            }
        }

        try {
            const response = await fetch(`${BASE_URL}/vendor/aboutus/update/${aboutUsId}`, {
                method: "PUT",
                headers: {
                    "Authorization": `Bearer ${token}`
                },
                body: formData
            });

            const responseText = await response.text();

            if (!response.ok) {
                throw new Error(`HTTP ${response.status}: ${responseText}`);
            }

            return responseText ? JSON.parse(responseText) : {};
        } catch (error) {
            console.error("🔴 [updateMissionVision] Error:", error);
            throw error;
        }
    },

    // DELETE Mission Vision
    deleteMissionVision: async (aboutUsId) => {
        const token = getToken();

        try {
            const response = await fetch(`${BASE_URL}/vendor/aboutus/delete/${aboutUsId}`, {
                method: "DELETE",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            });

            const text = await response.text();
            return text ? JSON.parse(text) : {};
        } catch (error) {
            console.error("🔴 [deleteMissionVision] Error:", error);
            throw error;
        }
    },

    // ================= TEAM MANAGEMENT =================

    // GET TEAM MEMBERS
    getTeamMembers: async () => {
        const vendorId = getVendorId();
        const token = getToken();

        try {
            const response = await fetch(`${BASE_URL}/adminteam/getall/${vendorId}`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            });

            if (!response.ok) {
                throw new Error("Failed to fetch team members");
            }

            const data = await response.json();
            return data;
        } catch (error) {
            console.error("🔴 [getTeamMembers] Error:", error);
            throw error;
        }
    },

    // ADD MEMBER
    addMember: async (name, designation, description, imageFile) => {
        const vendorId = getVendorId();
        const token = getToken();


        const formData = new FormData();

        const teamData = {
            teamId: 0,
            vendorId: Number(vendorId),
            name: name,
            designation: designation,
            description: description,
            image: ""
        };


        const jsonBlob = new Blob([JSON.stringify(teamData)], { type: "application/json" });
        formData.append("teamData", jsonBlob);

        if (imageFile) {
            formData.append("image", imageFile);
        }

        // Log formData
        for (let pair of formData.entries()) {
        }

        try {
            const response = await fetch(
                `${BASE_URL}/adminteam/addteam/${vendorId}`,
                {
                    method: "POST",
                    headers: {
                        "Authorization": `Bearer ${token}`
                    },
                    body: formData
                }
            );

            const text = await response.text();

            if (!response.ok) {
                console.error("API ERROR:", text);
                throw new Error("Add Member API Failed");
            }

            return text ? JSON.parse(text) : {};
        } catch (error) {
            console.error("🔴 [addMember] Error:", error);
            throw error;
        }
    },

    // UPDATE MEMBER
    updateMember: async (teamId, name, designation, description, imageFile, existingImage) => {
        const token = getToken();
        const vendorId = getVendorId();

        const formData = new FormData();

        const teamData = {
            teamId: teamId,
            vendorId: Number(vendorId),
            name: name,
            designation: designation,
            description: description,
            image: existingImage || ""
        };

        formData.append(
            "teamData",
            new Blob([JSON.stringify(teamData)], { type: "application/json" })
        );

        if (imageFile) {
            formData.append("image", imageFile);
        }

        try {
            const response = await fetch(
                `${BASE_URL}/adminteam/editbyid/${teamId}`,
                {
                    method: "PUT",
                    headers: {
                        "Authorization": `Bearer ${token}`
                    },
                    body: formData
                }
            );

            const text = await response.text();

            if (!response.ok) {
                console.error("Update API error:", text);
                throw new Error("Failed to update member");
            }

            return text ? JSON.parse(text) : {};
        } catch (error) {
            console.error("🔴 [updateMember] Error:", error);
            throw error;
        }
    },

    // DELETE MEMBER - Fix for object literal syntax (no 'static' keyword)
    deleteMember: async (teamId) => {
        const token = getToken();

        try {
            const response = await fetch(`${BASE_URL}/adminteam/delete/${teamId}`, {
                method: "DELETE",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            });


            if (!response.ok) {
                throw new Error("Failed to delete member");
            }

            // Get response as text (since API returns "Deleted successfully" as plain text)
            const textResponse = await response.text();

            // Return success without trying to parse as JSON
            return { success: true, message: textResponse };

        } catch (error) {
            console.error("🔴 [deleteMember] Error:", error);
            throw error;
        }
    },

    updateGallery: async (aboutUsId, formData) => {
        const token = getToken();


        // Log form data for debugging
        for (let pair of formData.entries()) {
            if (pair[1] instanceof File) {
                // console.log(`🟡 FormData: ${pair[0]} = File: ${pair[1].name}, size: ${pair[1].size}, type: ${pair[1].type}`);
            } else {
                // console.log(`🟡 FormData: ${pair[0]} =`, pair[1]);
            }
        }

        try {
            const response = await fetch(
                `${BASE_URL}/vendor/aboutus/update/${aboutUsId}`,
                {
                    method: "PUT",
                    headers: {
                        "Authorization": `Bearer ${token}`
                        // Don't set Content-Type - let browser set it with boundary
                    },
                    body: formData
                }
            );


            const responseText = await response.text();

            if (!response.ok) {
                throw new Error(`HTTP ${response.status}: ${responseText}`);
            }

            let data;
            try {
                data = responseText ? JSON.parse(responseText) : {};
            } catch (e) {
                data = { message: responseText };
            }

            return data;
        } catch (error) {
            console.error("🔴 [updateGallery] Error:", error);
            throw error;
        }
    },
    // In aboutUsService.jsx, add this new method

    // DELETE single image by ID
    deleteImage: async (imageId) => {
        const token = getToken();


        try {
            const response = await fetch(`${BASE_URL}/aboutus/image/delete/${imageId}`, {
                method: "DELETE",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            });


            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`Failed to delete image: ${errorText}`);
            }

            const responseText = await response.text();

            return { success: true, message: responseText };
        } catch (error) {
            console.error("🗑️ [deleteImage] Error:", error);
            throw error;
        }
    },


};